<template>
  <v-app>
    <v-app-bar app elevation="0" color="primary" dense>
      <div class="d-flex align-center">
        <v-img
          class="shrink mr-2 ml-4"
          contain
          :src="require('@/assets/logo.svg')"
          transition="scale-transition"
          width="80"
        />
      </div>
      <v-spacer></v-spacer>

      <v-btn href="https://www.tecnalia.com/tecnologias/ciberseguridad-y-blockchain" target="_blank" text>
        <span class="mr-2">Visítanos</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <IndyRegisterDidForm />
    </v-main>
  </v-app>
</template>

<script>
import IndyRegisterDidForm from "./components/IndyRegisterDidForm";

export default {
  name: "App",

  components: {
    IndyRegisterDidForm,
  },
  data: () => ({
    //
  }),
  created() {
    this.$store.commit("builcClient");
  },
};
</script>
